import {
    FETCH_RETAILERS_SUCCESS,
    FETCH_RETAILER_BY_ID_SUCCESS,

    RETAILERS_REQUEST_LOADING,
    RETAILERS_REQUEST_ERRORS
} from "api/menu/master-files/retailers/actions";

const initialState = {
    loading: false,
    errors: [],

    retailers: [],
    singleRetailer: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case RETAILERS_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case RETAILERS_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_RETAILERS_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                retailers: action.payload
            };
        case FETCH_RETAILER_BY_ID_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                singleRetailer: action.payload
            };
        default:
            return state;
    }
}
